import { render, staticRenderFns } from "./pos-page.vue?vue&type=template&id=332d5d78&scoped=true&"
import script from "./pos-page.vue?vue&type=script&lang=ts&"
export * from "./pos-page.vue?vue&type=script&lang=ts&"
import style0 from "./pos-page.vue?vue&type=style&index=0&id=332d5d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d5d78",
  null
  
)

export default component.exports